import { ISedmsFormModel } from 'src/app/shared/interfaces/form/sedms-form-model';
import { validateAddress, validateEmail, validatePhoneNumberMaskedTextBox } from '../../validators/validator';

export const AddScheduleMeetingFormModel: ISedmsFormModel = {
    parentSk: {
        name: 'parentSk',
    },
    isLocked: {
        name: 'isLocked',
    },
    contactName: {
        name: 'contactName',
        required: true,
        //validators: [{validator: validateName(false)}]
    },
    contactPhone: {
        name: 'contactPhone',
        validators: [{ validator: validatePhoneNumberMaskedTextBox(true) }]
    },
    contactEmail: {
        name: 'contactEmail',
        required: true,
        validators: [{ validator: validateEmail(true) }]
    },
    selectedRecipient: {
        name: 'selectedRecipient',
        required: true,
    },
    recipientEmailAddress: {
        name: 'recipientEmailAddress',
        validators: [{ validator: validateEmail(false) }]
    },
    recipientStreetAddress1: {
        name: 'recipientStreetAddress1',
    },
    recipientStreetAddress2: {
        name: 'recipientStreetAddress2',
    },
    recipientCity: {
        name: 'recipientCity',
    },
    recipientState: {
        name: 'recipientState',
    },
    recipientZip: {
        name: 'recipientZip',
    },
    meetingStreetAddress1: {
        name: 'meetingStreetAddress1',
        required: true,
        validators: [{ validator: validateAddress(true) }]
    },
    meetingStreetAddress2: {
        name: 'meetingStreetAddress2',
    },
    meetingFloorRoom: {
        name: 'meetingFloorRoom',
    },
    // meetingCity: {
    //     name: 'meetingCity',
    //     required : true,
    // },
    // meetingState: {
    //     name: 'meetingState',
    //     required : true,
    // },
    // meetingZip: {
    //     name: 'meetingZip',
    //     required : true,
    // },
    postalMail: {
        name: 'postalMail',
    },
    recipientPhoneNumber: {
        name: 'recipientPhoneNumber',
    },
    electronicMail: {
        name: 'electronicMail',
    },
    parentPortal: {
        name: 'parentPortal',
    },
    consentDate: {
        name: 'consentDate',
    },
    meetingDate: {
        name: 'meetingDate',
        required: true,
    },
    meetingStartTime: {
        name: 'meetingStartTime',
        required: true,
    },
    specialinstructions: {
        name: 'specialinstructions',
    },

    translationLanguage: {
        name: 'translationLanguage',
    },
    student: {
        studentName: {
            name: 'studentName',
        },
        studentEmail: {
            name: 'studentEmail',
            validators: [{ validator: validateEmail(false) }]
        }
    },
    parent: {
        parentName: {
            name: 'parentName',
        },
        parentEmail: {
            name: 'parentEmail',
            validators: [{ validator: validateEmail(false) }]
        }
    },
    generalEducationTeacher: {
        generalEducationTeacherName: {
            name: ' generalEducationTeacherName',
        },
        generalEducationTeacherEmail: {
            name: 'generalEducationTeacherEmail',
            validators: [{ validator: validateEmail(false) }]
        },
        generalEducationTeacherPhoneNumber: {
            name: 'generalEducationTeacherPhoneNumber',
        }
    },
    specialEducationTeacher: {
        specialEducationTeacherName: {
            name: 'specialEducationTeacherName',
        },
        specialEducationTeacherEmail: {
            name: 'specialEducationTeacherEmail',
            validators: [{ validator: validateEmail(false) }]
        },
        specialEducationTeacherPhoneNumber: {
            name: 'specialEducationTeacherPhoneNumber',
        }
    },

    schoolSocialWorker: {
        schoolSocialWorkerName: {
            name: 'schoolSocialWorkerName',
        },
        schoolSocialWorkerEmail: {
            name: 'schoolSocialWorkerEmail',
            validators: [{ validator: validateEmail(false) }]
        },
        schoolSocialWorkerPhoneNumber: {
            name: 'schoolSocialWorkerPhoneNumber',
        }
    },
    schoolPsychologist: {
        schoolPsychologistName: {
            name: 'schoolPsychologistName',
        },
        schoolPsychologistEmail: {
            name: 'schoolPsychologistEmail',
            validators: [{ validator: validateEmail(false) }]
        },
        schoolPsychologistPhoneNumber: {
            name: 'schoolPsychologistPhoneNumber',
        }
    },
    relatedServiceProvider: {
        relatedServiceProviderName: {
            name: 'relatedServiceProviderName',
        },
        relatedServiceProviderEmail: {
            name: 'relatedServiceProviderEmail',
            validators: [{ validator: validateEmail(false) }]
        },
        relatedServiceProviderPhoneNumber: {
            name: 'relatedServiceProviderPhoneNumber',
        }
    },
    districtRepresentative: {
        districtRepresentativerName: {
            name: 'districtRepresentativerName',
        },
        districtRepresentativerEmail: {
            name: 'districtRepresentativerEmail',
            validators: [{ validator: validateEmail(false) }]
        },
        districtRepresentativerPhoneNumber: {
            name: 'districtRepresentativerPhoneNumber',
        }
    },

    principal: {
        principalName: {
            name: 'principalName',
        },
        principalEmail: {
            name: 'principalEmail',
            validators: [{ validator: validateEmail(false) }]
        }
    },
    teacher: {
        teacherName: {
            name: 'teacherName',
        },
        teacherEmail: {
            name: 'teacherEmail',
            validators: [{ validator: validateEmail(false) }]
        }
    },

    attendee:
        [{
            name: 'selectedAttendee',
            required: true,
        },
        {
            name: 'role',
            required: true,
        },
        {
            name: 'name',
        }, {
            name: 'email',
            validators: [{ validator: validateEmail(true) }]
        },
        {
            name: 'isRequired'

        }
        ],
    omh: {
        name: 'omh',
    },
    opwdd: {
        name: 'opwdd',
    },
    accesvr: {
        name: 'accesvr',
    },
    none: {
        name: 'none',
    },
    other: {
        name: 'other',
    },
    otherProvider: {
        name: 'otherProvider',
    },
    meetingOutcome: {
        name: 'meetingOutcome'
    }

};